<div class="league-header">
    <div class="league-header-content">
        <h1>Leagues</h1>
        <button class="basic-btn-red" (click)="goToNewLeague()">+ New League</button>
    </div>
</div>
<div class="routed-container">
    <div class="routed-content">
        <div *ngIf="!loading; else loadingMsg">
            <p *ngIf="err" class="error-message">{{ err }}</p>
            <div *ngIf="leagues.length > 0; else noLeagues" class="league-list">
                <div *ngFor="let league of leagues" class="league-item">
                    <h2 class="league-name">{{ league.league_name }}</h2>
                    <div class="league-body">
                        <div class="league-body-details">
                            <h3 class="league-dates">{{league.league_start}} - {{league.league_end}}</h3>
                            <p class="no-mt"><span [ngClass]="{'trivia-badge': league.game_type.name === 'King Trivia', 'slam-badge': league.game_type.name === 'Survey Slam'}">{{league.game_type.name}}</span></p>
                            <div class="league-info" [ngClass]="{'local-league-info': isLocal(league)}">
                                <p class="league-type">{{!isLocal(league) ? 'National League' : 'Local League'}}</p>
                                <div *ngIf="league.league_venues.length"><p>Only at venues: </p>
                                    <ul>
                                        <li *ngFor="let venue of league.league_venues; let i = index">{{ venue.name }}</li>
                                    </ul>
                                </div>
                                <p *ngIf="league.city">Only within {{ league.distance }}km of {{ league.city ? league.city + ', ' : '' }}{{ league.state }}</p>
                                <p *ngIf="league.state && !league.city">Only in {{ league.state }}</p>
                                <p>{{scoreType(league)}} for best {{league.max_game}} games. <span *ngIf="league.min_game > 0">Minimum {{league.min_game}} games to qualify.</span></p>
                            </div>
                            <p class="league-status" [ngClass]="{'in-progress': league.status === 'In Progress', 'completed': league.status === 'Completed'}">{{league.status}}</p>
                        </div>
                        <div class="league-actions">
                            <a href="{{playerUri}}/league/{{league.kt_league_id}}"><button class="basic-btn-green">View</button></a>
                            <button class="basic-btn-blue" (click)="startEditLeague(league)">Edit</button>
                            <button class="basic-btn-red" (click)="confirmDeleteLeague(league)">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="league-list-bumper">
                <h2>Bumper</h2>
                <h2>Bumper</h2>
            </div>
        </div>
    </div>
</div>

<app-basic-modal *ngIf="leagueToEdit" [template]="editLeagueContent" [hideX]="true"
  [staticBackground]="true" [title]="'Edit League'" [cancel]="''"
  [action]="''">
</app-basic-modal>

<ng-template #editLeagueContent>
    <app-league-form [league]="leagueToEdit" [parentLoading]="loading" [parentError]="err" (updateLeague)="updateLeague($event)" (cancelEditLeague)="cancelEditLeague()"></app-league-form>
</ng-template>

<ng-template #loadingMsg>
    <h2 class="center-text">Loading Leagues...</h2>
</ng-template>

<ng-template #noLeagues>
    <h2 class="center-text">No Leagues Found</h2>
</ng-template>